<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<p class="half">THE ROMAN KING ARTHUR?</p>
<p class="halfa">Lucius Artorius Castus</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Half.vue?c03fc460